import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { bulkUploadCompanies } from "../../../middleware/backend_hepler";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BulkCompany = () => {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const navigate = useNavigate();

  const methods = useForm();

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if (!data.csv_file[0]) {
      toast.error("Please upload a CSV file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", data.csv_file[0]);

    try {
      setLoading(true);
      const response = await bulkUploadCompanies(formData);
      setLoading(false);

      toast.success("Bulk upload successful!");
      setTimeout(() => navigate("/companylist"), 2000);
    } catch (error) {
      setLoading(false);
      console.error("Error in bulk upload:", error);
      toast.error("Failed to upload. Please try again.");
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("");
    }
  };

  return (
    <div className="edit-all-loan-container">
      <div className="edit-back-icon">
        <div
          className="edit-back-text"
          onClick={() => navigate("/companylist")}
        >
          &lt; Go Back
        </div>
      </div>

      <h2>Company</h2>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row">
            <div className="sections personal-details-sections mt-4">
              <label htmlFor="csv_file" className="document-label">
                Bulk Company Upload
              </label>
              <input
                type="file"
                id="csv_file"
                accept=".csv"
                {...register("csv_file")}
                onChange={handleFileChange}
                className="form-control-file"
              />
              <span className="file-upload-message">
                Please upload a CSV file with a maximum of 5000 rows.
              </span>
            </div>
            <div className="button-container text-center">
              <Button
                variant="success"
                type="submit"
                className="custom-submit-button"
                disabled={isSubmitting || loading}
              >
                {loading ? "Uploading..." : "Upload"}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default BulkCompany;
